import { formatPriceThousands } from '@/utils/configs/price.config';
/**
 * 处理产品简介里的变量
 * @param {object} productDetail 产品详情，从产品详情内取产品简介 introduction
 * @param {object} country 国家地区
 */
export const handleProductIntroduction = ({ productDetail = {}, country }) => {
  let defaultIntroduction = productDetail?.info?.introduction ?? '';

  // VB预售产品
  if (productDetail?.id === 571) {
    // 预售定金、正式开售折扣金额、正式开售起步价、正式开售最高价
    const priceMap = {
      'USD': [100, 200, 1500, 2000],
      'CAD': [100, 200, 2500, 3000],
      'GBP': [100, 200, 1500, 2000],
      'EUR': [100, 200, 2000, 2500],
    };
    const curCurrencyConfig = priceMap[country?.currency];
    if (!curCurrencyConfig) return defaultIntroduction;

    curCurrencyConfig.forEach((amount, i) => {
      const formatPrice = formatPriceThousands({ price: amount, country });
      defaultIntroduction = defaultIntroduction.replace(`__PRICE${i + 1}__`, `<span>${formatPrice}</span>`);
    });
  }

  return defaultIntroduction;
};

export default { handleProductIntroduction };
